import axios from "@/plugins/axios";
import bids from "./bids";

let url = "/api/console/auction/works";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
    postWonEmail(data) {
        return axios.post(`${url}/${data._id}/wonEmail`, data).then((result) => result.data);
    },
    bids,
};
